/* eslint complexity: ["error", 5], max-params: ["error", 2], max-depth: ["error", 3], max-statements: ["error", 10] */
const ShoppingCart = require('od-modules/cart/cart');

module.exports = function() {
    'use strict';
    var PriceSubscriberMixin = require('../mixins/price_subscriber.mixin');

    return Odigeo.Model.extend(PriceSubscriberMixin.extend({
        defaults: {
            'page': '',
            'price': -1,
            'seatmap': {},
            'paxNameList': [],
            'isPrimeBlocked': false,
            'isUpdatedMembershipPrices': false,
            'totalPrice': 0,
            'finalPrice': 0,
        },

        initialize: function() {
            this.bindPriceCollection();
            this.on('priceCollection.repaintPrices', this.refreshPrice);
            ShoppingCart.subscribe(this.refreshPrice.bind(this));
        },

        isPrimeEnabled: function() {
            return Odigeo.Membership.isMembershipProductEnabled && !Odigeo.SessionScope.isMeta;
        },

        isSlowLoadingPrimePriceFix: function() {
            const isDiscountSelected = !this.widget.isPriceWithoutDiscountSelected();
            const isUpdatedMembershipPrices = this.get('isUpdatedMembershipPrices');
            const isPayment = this.widget.view.isPayment();
            return this.isPrimeEnabled() && isDiscountSelected && !isUpdatedMembershipPrices && !isPayment;
        },

        isRefreshPriceAllowed: function(isSlowLoadingPrimePriceFix) {
            return !isSlowLoadingPrimePriceFix || (isSlowLoadingPrimePriceFix && this.getUnformattedTicketPrice() > 0.0);
        },

        refreshPrice: function() {
            const isSlowLoadingPrimePriceFix = this.isSlowLoadingPrimePriceFix();
            const finalPrice = isSlowLoadingPrimePriceFix ? this.getTicketPrice() : this.getFinalPrice();
            const pricePerPassenger = isSlowLoadingPrimePriceFix ? this.getTicketPricePerPassenger() : this.getPricePerPassenger();
            if (this.isRefreshPriceAllowed(isSlowLoadingPrimePriceFix)) {
                this.trigger('updatePrices', finalPrice, pricePerPassenger, this.getSHPrice());
            }
        },

        updateDataSource: function(page) {
            var dataSource = {
                'details': function() {
                    this.set({
                        'page': page,
                    });
                },
                'metaancillaries': function() {
                    var bookingPaxList = Odigeo.Utils.parseJson(Odigeo.Session.get('booking_pax_list')) || {};
                    var paxNameList = Odigeo._.pluck(bookingPaxList, 'name') || {};
                    var seatmap = this.getSeatmapFromSession();

                    paxNameList = Odigeo._.map(bookingPaxList, function(obj) {
                        return {
                            fullName: obj.name + ' ' + obj.firstLastName,
                        };
                    });

                    this.set({
                        'page': page,
                        'seatmap': seatmap,
                        'paxNameList': paxNameList,
                    });
                },
                'payment': function() {
                    var bookingPaxList = Odigeo.Utils.parseJson(Odigeo.Session.get('booking_pax_list')) || {};
                    var paxNameList = Odigeo._.pluck(bookingPaxList, 'name') || {};
                    var seatmap = this.getSeatmapFromSession();

                    paxNameList = Odigeo._.map(bookingPaxList, function(obj) {
                        return {
                            fullName: obj.name + ' ' + obj.firstLastName,
                        };
                    });

                    this.set({
                        'page': page,
                        'seatmap': seatmap,
                        'paxNameList': paxNameList,
                    });
                },
            };
            return dataSource[page].apply(this, arguments);
        },
        setSeatMapFromCollection: function(seatMapCollection) {
            var seatMap = {
                allprice: seatMapCollection.getSelectedSeatsPrice(),
                quantity: seatMapCollection.getSelectedSeatsLength(),
            };

            this.set({'seatmap': seatMap});
        },
        getSeatmapFromSession: function() {
            var seatPreferenceSelection = Odigeo.Utils.parseJson(Odigeo.Session.get('seatPreferenceSelection')) || [];
            var allprice = Odigeo._.reduce(seatPreferenceSelection, function(memo, seat) {
                return memo + (Odigeo._.has(seat, 'totalPrice') ? seat.totalPrice : 0);
            }, 0);
            return {
                allprice: allprice,
                quantity: seatPreferenceSelection.length,
            };
        },
    }));
}();
